<template>
  <div>
    <van-search
      autocomplete="off"
      v-model="queryParams.name"
      @search="onSubmit"
      @clear="onSubmit"
      placeholder="请输入供应商名称进行查询"
    >
      <template #right-icon>
        <van-icon name="filter-o" @click="openFilter" />
      </template>
    </van-search>

    <!-- 供应商列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已显示全部"
      ref="scrollContainer"
      @load="getList(true)"
    >
      <div
        v-for="item in tableData"
        :key="item.id"
        class="container"
        touch-action="pan-y"
      >
        <div class="available">
          <div class="">
            <div
              :class="[
                {
                  color1: item.available,
                  color2: !item.available,
                },
                'status',
              ]"
            >
              {{ item.available ? "启用" : "停用" }}
            </div>
          </div>
        </div>
        <div class="content">
          <div class="left">
            <div class="item flex">
              <div class="label">供应商名称:</div>
              <div class="value">{{ item.name }}</div>
            </div>
            <div class="item flex">
              <div class="label">供应商编号:</div>
              <div class="value">{{ item.code }}</div>
            </div>
            <div class="item flex">
              <div class="label">备注:</div>
              <div class="value">{{ item.description || "-" }}</div>
            </div>
          </div>
          <div class="actions">
            <div @click="handleView(item)">查看</div>
            <div @click="handleEdit(item)">修改</div>
          </div>
        </div>
      </div>
    </van-list>

    <!-- 筛选弹窗 -->
    <van-popup
      v-model:show="filterVisible"
      position="top"
      :style="{ height: '40%' }"
    >
      <div class="filter-content">
        <div class="filter-title">筛选条件</div>
        <div class="filter-item">
          <div class="filter-label">状态</div>
          <div class="filter-options">
            <span
              v-for="option in statusOptions"
              :key="option.value"
              :class="{ active: queryParams.available === option.value }"
              @click="selectStatus(option.value)"
            >
              {{ option.label }}
            </span>
          </div>
        </div>
        <div class="filter-actions">
          <van-button size="small" @click="resetFilter">重置</van-button>
          <van-button size="small" type="primary" @click="confirmFilter">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 底部新增按钮 -->
    <div class="bottom-add-btn">
      <van-button type="primary" block @click="handleAdd"
        >新增供应商</van-button
      >
    </div>
  </div>
</template>

<script>
import * as supplierApi from "@/service/api/basedata/supplier";

export default {
  name: "Supplier",
  data() {
    return {
      loading: false,
      finished: false,
      filterVisible: false,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      queryParams: {
        name: "",
        available: true,
      },
      statusOptions: [
        { label: "全部", value: null },
        { label: "启用", value: true },
        { label: "停用", value: false },
      ],
    };
  },
  mounted() {
    this.onSubmit();
    setInterval(() => {}, 4000);
  },
  methods: {
    openFilter() {
      this.filterVisible = true;
    },
    selectStatus(value) {
      this.queryParams.available = value;
    },
    resetFilter() {
      this.queryParams.name = "";
      this.queryParams.available = true;
    },
    confirmFilter() {
      this.filterVisible = false;
      this.onSubmit();
    },
    onSubmit() {
      this.pageIndex = 1;
      this.tableData = [];
      this.finished = false;
      this.getList();
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        name: this.queryParams.name,
        available: this.queryParams.available,
      };
      supplierApi
        .query(params)
        .then((res) => {
          this.finished = false;
          this.loading = false;
          if (res.data && res.data.datas) {
            if (load) {
              this.tableData = this.tableData.concat(res.data.datas);
            } else {
              this.tableData = res.data.datas;
            }
            this.totalCount = res.data.totalCount || 0;
            this.totalPage = res.data.totalPage || 1;
            if (this.pageIndex >= this.totalPage) {
              this.finished = true;
            }
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },

    handleAdd() {
      this.$router.push("/product/supplierDetail/add");
    },

    handleView(item) {
      this.$router.push(`/product/supplierDetail/${item.id}/view`);
    },

    handleEdit(item) {
      this.$router.push(`/product/supplierDetail/${item.id}/edit`);
    },

    handleToggleStatus(item) {
      const action = item.available ? "停用" : "启用";
      this.$dialog
        .confirm({
          title: "确认",
          message: `确定要${action}该供应商吗？`,
        })
        .then(() => {
          const ids = [item.id];
          if (item.available) {
            supplierApi
              .batchUnable(ids)
              .then(() => {
                this.$toast.success(`${action}成功`);
                this.onSubmit();
              })
              .catch((e) => {
                console.error(e);
                this.$toast.fail(`${action}失败`);
              });
          } else {
            supplierApi
              .batchEnable(ids)
              .then(() => {
                this.$toast.success(`${action}成功`);
                this.onSubmit();
              })
              .catch((e) => {
                console.error(e);
                this.$toast.fail(`${action}失败`);
              });
          }
        })
        .catch(() => {
          // 用户取消
        });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  touch-action: pan-y;
}

.container {
  margin-top: 5px;
  padding: 10px 0 10px 10px;
  background-color: #fff;
  position: relative;
  .available {
    position: absolute;
    right: 0;
    font-size: 15px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tit {
      flex: 1;
    }
    .status {
      width: 5rem;
      height: 26px;
      line-height: 26px;
      text-align: center;
      flex: 2;
      margin-left: 20px;
      border-radius: 13px 0 0 13px;
      color: #fff;
      overflow: hidden;
      font-size: 14px;
    }

    .color1 {
      background: linear-gradient(83deg, #07c160, #98bf8c);
    }

    .color2 {
      background: linear-gradient(83deg, red, #bfa98c);
    }
  }
  .content {
    margin-top: 10px;
    font-size: 14px;
    padding: 0;
    .left {
      .item {
        width: 14rem;
        margin: 8px 0;
        font-size: 14px;
        .label {
          min-width: 6rem;
          color: #333;
        }
        .value {
          color: #666;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
        }
      }
      .flex {
        display: flex;
      }
    }
    .actions {
      padding-top: 5px;
      border-top: 1px solid #eee;
      display: flex;
      align-items: center;
      div {
        flex: 1;
        text-align: center;
        color: #409eff;
        font-size: 14px;
      }
    }
  }
}

.filter-content {
  padding: 15px;
  .filter-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .filter-item {
    margin-bottom: 15px;
    .filter-label {
      font-size: 14px;
      margin-bottom: 8px;
      color: #333;
    }
    .filter-options {
      display: flex;
      gap: 10px;
      span {
        padding: 5px 15px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        &.active {
          border-color: #1989fa;
          background-color: #1989fa;
          color: #fff;
        }
      }
    }
  }
  .filter-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
}

.bottom-add-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 15px;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

::v-deep .van-list {
  height: calc(100vh - 128px);
  overflow-y: auto;
  padding-bottom: 60px;
}
</style>
